import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Legends } from './models/legends.interfaces';

@Component({
  selector: 'idp-legends',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './legends.component.html',
  styleUrls: ['./legends.component.scss']
})
export class LegendsComponent {
  @Input() content: Legends = {} as Legends;
}
